export default __webpack_public_path__ + "static/media/english-to-finnish-logo.346d7329.png";